import script from "./HomeFacultyReport.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeFacultyReport.vue?vue&type=script&setup=true&lang=js"

import "./HomeFacultyReport.vue?vue&type=style&index=0&id=b72c678a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b72c678a"]])

export default __exports__